<template>
  <div class="navMobileWrapper">
    <width_expand>
      <notification_space />
    </width_expand>
    <div v-click-outside="closeMenu" class="clickWrap">
      <burger :open="expand" @toggle="toggleMenu" />
      <height_expand>
        <div
          v-if="expand"
          class="contextMenu"
          :class="{ notLogged: !is_logged_in }"
        >
          <nav_mobile_list
            v-if="is_logged_in"
            class="mainParentContainer"
            @close="closeMenu"
          />
          <div v-else class="colDisplay">
            <nuxt-link to="/influencer/signup/">
              <b>{{ $t("layout.navigation09") }}</b>
            </nuxt-link>
            <div @click="openLogin">
              {{ $t("layout.navigation07") }}
            </div>
            <action_button @click="openSignup">
              <div class="btnText">
                {{ $t("layout.navigation06") }}
              </div>
            </action_button>
          </div>
        </div>
      </height_expand>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"

import nav_mobile_list from "~/components/nav/mobile/list"
import burger from "~/components/nav/mobile/burger"
import action_button from "~/components/shared/actionButton"
import width_expand from "~/components/transitions/widthExpand"
import height_expand from "~/components/transitions/heightExpand"
import notification_space from "~/components/nav/navigation/notificationSpace"

import resize_mixin from "~/mixins/resize"

export default {
  components: {
    burger,
    width_expand,
    height_expand,
    action_button,
    nav_mobile_list,
    notification_space,
  },
  mixins: [resize_mixin],
  data: function () {
    return {
      expand: false,
    }
  },
  computed: {
    ...mapGetters({
      is_logged_in: "user/IS_LOGGED_IN",
    }),
  },
  methods: {
    closeMenu: function () {
      this.expand = false
      this.commonMenuLogic()
    },
    toggleMenu: function () {
      this.expand = !this.expand
      this.commonMenuLogic()
    },
    commonMenuLogic: function () {
      if (this.screenWidth < 480) {
        if (this.expand) this.SET_MENU_FULL_SCREEN()
        else this.RESET_MENU()
      }
    },
    openLogin: function () {
      this.login_set_display(true)
    },
    openSignup: function () {
      this.band_signup_set_display(true)
    },
    ...mapActions({
      login_set_display: "login/SET_DISPLAY",
      band_signup_set_display: "band_signup/SET_DISPLAY",
      SET_MENU_FULL_SCREEN: "misc/menu/SET",
      RESET_MENU: "misc/menu/RESET",
    }),
  },
  watch: {
    screenWidth: function () {
      if (this.screenWidth >= 480) this.RESET_MENU()
    },
  },
}
</script>
<style scoped src="./mobile.css"></style>
